import React, { useState, useEffect } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { signInAnonymously, onAuthStateChanged } from 'firebase/auth'
import { db, auth } from '../firebase/firebase'
import LikeButton from './LikeButton'

const ArticleLike = ({ articleId }) => {
  const [anonUid, setAnonUid] = useState(null)
  const [count, setCount] = useState(0)

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setAnonUid(user.uid)
      } else {
        const cred = await signInAnonymously(auth)
        setAnonUid(cred.user.uid)
      }
    })
    return unsub
  }, [])

  useEffect(() => {
    if (!articleId) return
    const unsub = onSnapshot(doc(db, 'articles', articleId), snap => {
      setCount(snap.data()?.likesCount || 0)
    })
    return unsub
  }, [articleId])

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginTop: '24px',
      paddingTop: '16px',
      borderTop: '1px solid #eee',
    }}>
      <LikeButton itemId={articleId} count={count} anonUid={anonUid} collectionName='articles' />
    </div>
  )
}

export default ArticleLike
